const SEMVER_REGEX = /^(?<major>\d{1,4})\.(?<minor>\d{1,4})\.(?<patch>\d{1,4})(?:-(?<prerelease>\d{0,7}))?$/s;
function mapSemverToVersion(semver) {
    const matches = SEMVER_REGEX.exec(semver);
    if (!matches) {
        return semver;
    }
    const major = matches.groups?.major || "0000";
    const minor = matches.groups?.minor || "0000";
    const patch = matches.groups?.patch || "0000";
    const prerelease = matches.groups?.prerelease || "";
    return `${major.padStart(4, "0")}${minor.padStart(4, "0")}${patch.padStart(4, "0")}${prerelease.padStart(7, "0")}`;
}
function mapVersionToSemver(version) {
    if (!/^\d{19}$/.test(version)) {
        return version;
    }
    const major = String(Number(version.substring(0, 4)));
    const minor = String(Number(version.substring(4, 8)));
    const patch = String(Number(version.substring(8, 12)));
    const prerelease = String(Number(version.substring(12)));
    let output = `${major}.${minor}.${patch}`;
    if (prerelease !== "" && prerelease !== "0") {
        output += `-${prerelease}`;
    }
    return output;
}
export { mapSemverToVersion, mapVersionToSemver };
